module.exports = __webpack_public_path__ + "img/woman-call.6249936a.jpg";